import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { uploadManufacturersCsv, getCsvManufacturerModel } from '../app/store/actions/manufacturers';
import UploadFilesComponent from '../components/upload';
import ManufacturerImportErrors from '../components/upload/ManufacturerImportErrors';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class UploadManufacturersPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
  }

  sendFile = async (file) => {
    await this.setState({ errors: {} });
    const result = await this.props.uploadManufacturersCsv(file);
    await this.setState({ errors: (result && result.errors) || [] });
  }

  modelDownload = async () => {
    await this.props.getCsvManufacturerModel();
  }

  goBack = () => {
    history.push(ROUTES.MANUFACTURERS);
  }

  render() {
    const { errors } = this.state;

    return (
      <div className="main-div-tables">
        <div className="main-table">
          <h2><Translate value="importManufacturers" /></h2>

          <div className="upload-text">
            <p><strong><Translate value="importText1" /></strong></p>
            <p><Translate value="importText2" /></p>
            <p><Translate value="importText3" /></p>
            <p><Translate value="importText4" /></p>
            <p><Translate value="manufacturerImportText11" /></p>
            {/* <p><Translate value="manufacturerImportText22" /></p> */}
            <p><Translate value="manufacturerImportText33" /></p>
          </div>


          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
            itemsErrors={<ManufacturerImportErrors errors={errors} />}
          />

        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadManufacturersCsv: file => dispatch(uploadManufacturersCsv(file)),
  getCsvManufacturerModel: () => dispatch(getCsvManufacturerModel()),
});

export default connect(null, mapDispatchToProps)(UploadManufacturersPage);
